import {
  FilterAttributes,
  FilterSelectionsInterface,
  ProductAttributeInterface
} from "@gea-waldviertler-website/gea-models";


export interface CheckEmailResponseInterface {
  exists: boolean
  passwordResetRequired: boolean
}

export type CountryCodes = "DE" | "AT"

export interface PostcodeEuAutocompleteItemInterface {
  value: string
  label: string
  description: string
  precision: string
  context: string
  highlights: [number, number][]
}

export interface PostcodeEuAutocompleteInterface {
  newContext: string | null
  matches: PostcodeEuAutocompleteItemInterface[]
}

export interface PostcodeEuResponseInterface {
  language: string
  address: {
    country: string
    locality: string
    street: string
    postcode: string
    building: string
    buildingNumber: number
    buildingNumberAddition: string | null
  }
  mailLines: string[]
  location:  {
    latitude: number
    longitude: number
    precision: string
  }
  isPoBox: boolean,
  country: {
    name: string
    iso3Code: string
  }
  details: any
}

export interface FilterChangesInterface {
  filterSelections: FilterSelectionsInterface
  filterAttributes?: FilterAttributes
}

export class ProductAttributesFilterView {

  fs: FilterSelectionsInterface

  constructor(
    filterSelections: FilterSelectionsInterface | undefined
  ) {
    if (filterSelections) {
      this.fs = filterSelections
    } else {
      this.fs = {} as FilterSelectionsInterface
    }
  }

  getCount(attribute: ProductAttributeInterface): number {
    let count = 0
    if (this.fs.hasOwnProperty(attribute.code)
      && this.fs[attribute.code]?.selections
      && Array.isArray(this.fs[attribute.code]?.selections)) {
      return this.fs![attribute.code]!.selections!.length
    }
    return count
  }
}